import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { memo } from 'react';
import { Box, Typography } from '@mui/material';
import { Warning } from '@mui/icons-material';
export const ErrorBox = memo(function ErrorBoxImpl({ error, }) {
    return (_jsxs(Box, { display: "flex", alignItems: "center", children: [_jsx(Box, { mr: 1, children: _jsx(Warning, { color: "error" }) }), _jsx(Typography, { variant: "subtitle1", color: "error", children: error })] }));
});
